import React from 'react'

function _IconCard(props: React.SVGProps<SVGSVGElement>, ref?: React.Ref<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16699 6.50049C2.16699 5.81013 2.72664 5.25049 3.41699 5.25049H21.417C22.1073 5.25049 22.667 5.81013 22.667 6.50049V9.75049H2.16699V6.50049ZM0.666992 10.5005V6.50049C0.666992 4.98171 1.89821 3.75049 3.41699 3.75049H21.417C22.9358 3.75049 24.167 4.98171 24.167 6.50049V10.5005V18.5005C24.167 20.0193 22.9358 21.2505 21.417 21.2505H3.41699C1.89821 21.2505 0.666992 20.0193 0.666992 18.5005V10.5005ZM22.667 11.2505V18.5005C22.667 19.1908 22.1073 19.7505 21.417 19.7505H3.41699C2.72664 19.7505 2.16699 19.1908 2.16699 18.5005V11.2505H22.667Z"
        fill="currentColor"
      />
    </svg>
  )
}

const IconCard = React.memo(React.forwardRef(_IconCard))

export { IconCard }
